import Immutable from 'immutable';
import _ from 'underscore';
import { isStripeField } from 'lib/form/stripe_fields';
import FormValidation from './validation.js';
import FormSubmit from './submit.js';

const FormController = {
  mixins: [FormValidation, FormSubmit],
  onChange(field, newValue) {
    // need to add to state as stripe is also gettinig postalCode
    if (field.elementType === 'postalCode') {
      this.setState({
        fields: this.state.fields.set('billing_zip_code', field.value),
      });
    }

    if (this._fieldChanged(field, newValue)) {
      this.setState(
        {
          fields: this.state.fields.set(field, newValue),
        },
        () => {
          this._fireLocalChangedEvent(field, newValue);
        }
      );
    } else if (isStripeField(field.elementType)) {
      const { fieldsCompleted = [] } = this.state.stripe || {};
      const updatedFieldsCompleted = field.complete
        ? fieldsCompleted.concat(field.elementType)
        : fieldsCompleted.filter((element) => element !== field.elementType);

      this.setState({
        stripe: {
          fieldsCompleted: updatedFieldsCompleted,
        },
      });
    }
  },

  _fieldChanged(field, newValue) {
    const imNewValue = Immutable.fromJS(newValue);
    const imOldValue = Immutable.fromJS(this.state.fields.get(field));

    return !(imNewValue === imOldValue);
  },

  _fireLocalChangedEvent(field, newValue) {
    if (this.onFieldChanged && this.onFieldChanged[field]) {
      this[this.onFieldChanged[field]](newValue);
    }
  },

  _sectionFieldKeys(section) {
    return this.formSections[section];
  },

  _sectionFields(section) {
    return this._sectionState('fields', section);
  },

  _sectionErrors(section) {
    return this._sectionState('errors', section);
  },

  _sectionState(interest, section) {
    const pickArgs = _.union(
      [this.state[interest].toJS()],
      this._sectionFieldKeys(section)
    );

    return _.pick.apply(null, pickArgs);
  },

  _sectionValidations(section) {
    const validations = this.validationConstraints();
    const pickArgs = _.union([validations], this._sectionFieldKeys(section));
    return _.pick.apply(null, pickArgs);
  },

  _formProps(fieldName, otherProps) {
    return _.extend(
      {
        name: fieldName,
        value: this.state.fields.get(fieldName),
        errors: this.state.errors.get(fieldName),
        onChange: this.onChange,
      },
      otherProps
    );
  },

  _formProxyProps(section, otherProps) {
    return _.extend(
      {
        fields: Immutable.Map(this._sectionFields(section)),
        errors: Immutable.Map(this._sectionErrors(section)),
        onChange: this.onChange,
        onSubmit: this._onProxySubmit.bind(null, section),
      },
      otherProps
    );
  },
};

export default FormController;
